/**
 * ReviewDetailPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable } from 'components';
import { Input, Button, Rate, Avatar } from 'antd';
import { PictureOutlined } from '@ant-design/icons';

const content = `최고 최고! 
🥲🥲🥲🥲🥲🥲😝 
커피향이 정말 좋고 맛있어요!`;

const ReviewDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '상품명',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <button
                style={{
                  border: 'none',
                  background: 'none',
                  textDecoration: 'underline',
                  color: '#1C6BFF',
                  cursor: 'pointer',
                }}
              >
                [과테말라] 디카페인 200g
              </button>
            </>
          ),
        },
        {
          input: (
            <>
              <p>평점: 4.2점</p>
            </>
          ),
        },
      ],
    },
    {
      label: '아이디',
      form: [
        {
          input: (
            <>
              <p>user1234</p>
            </>
          ),
        },
      ],
    },
    {
      label: '리뷰 유형',
      form: [
        {
          input: (
            <>
              <p>텍스트</p>
            </>
          ),
        },
      ],
    },
    {
      label: '별점',
      form: [
        {
          input: (
            <>
              <Rate value={5} />
            </>
          ),
        },
        {
          input: (
            <>
              <p>5.0점</p>
            </>
          ),
        },
      ],
    },
    {
      label: '내용',
      form: [
        {
          input: (
            <div style={{ height: 162, overflow: 'auto' }}>
              <pre>{content}</pre>
            </div>
          ),
        },
      ],
    },
    {
      label: '사진',
      form: [
        {
          input: (
            <div>
              {[1, 2, 3].map((_, key) => (
                <Avatar
                  size={104}
                  shape="square"
                  key={`image_${key}`}
                  icon={<PictureOutlined />}
                  style={{ marginRight: 20 }}
                />
              ))}
            </div>
          ),
        },
      ],
    },
    {
      label: '리뷰 답글',
      form: [
        {
          input: (
            <Input.TextArea
              placeholder="답변을 등록해주세요. (300자이내)"
              style={{ width: '100%', height: 147 }}
            />
          ),
          fullscreen: true,
          count: true,
          maxLength: 300,
        },
      ],
    },
    {
      label: '적립금 지급 여부',
      form: [
        {
          input: (
            <>
              <p>N</p>
            </>
          ),
        },
        {
          input: (
            <>
              <Button
                type="primary"
                size="small"
                style={{ background: 'var(--primary-color)', marginLeft: 25 }}
              >
                적립 확인
              </Button>
            </>
          ),
        },
      ],
    },
    {
      label: '쿠폰 여부',
      form: [
        {
          input: (
            <>
              <p>N</p>
            </>
          ),
        },
        {
          input: (
            <>
              <Button
                type="primary"
                size="small"
                style={{ background: 'var(--primary-color)', marginLeft: 25 }}
              >
                쿠폰 지급
              </Button>
            </>
          ),
        },
      ],
    },
    {
      label: '베스트리뷰 여부',
      form: [
        {
          input: (
            <>
              <p>N</p>
            </>
          ),
        },
        {
          input: (
            <>
              <Button
                type="primary"
                size="small"
                style={{ background: 'var(--primary-color)', marginLeft: 25 }}
              >
                선정
              </Button>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>리뷰 상세정보</Title>

          {/* 기본정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 20 }}
          >
            <InputFormTable form={form1} />
          </Content>
          {/* 기본정보 끝 */}

          {/* 버튼 */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button size="large" style={{ ...styles.button }}>
                취소
              </Button>
              <Button
                type="primary"
                size="large"
                style={{
                  background: 'var(--primary-color)',
                }}
              >
                답글 등록
              </Button>
            </div>
          </Content>
          {/* 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default ReviewDetailPresenter;
